import axios from "axios";
import flavours from "@/mixins/flavours";

const serverPool = [
  "s0.2kbo.com",
  "s1.2kbo.com",
  "s2.2kbo.com",
  "s3.2kbo.com",
  "s4.2kbo.com",
  "s5.2kbo.com",
  "s6.2kbo.com",
  "s7.2kbo.com",
  "s8.2kbo.com",
  "s9.2kbo.com",
  "s10.2kbo.com",
  "s11.2kbo.com",
  "s12.2kbo.com",
  "s13.2kbo.com",
  "s14.2kbo.com",
  "s15.2kbo.com",
  "s16.2kbo.com",
  "s17.2kbo.com",
  "s18.2kbo.com",
  "s19.2kbo.com",
  "s20.2kbo.com",
];

const neositekServerPool = [
  "s0.neositek.com",
  "s1.neositek.com",
  "s2.neositek.com",
  "s3.neositek.com",
  "s4.neositek.com",
  "s5.neositek.com",
  "s6.neositek.com",
  "s7.neositek.com",
  "s8.neositek.com",
  "s9.neositek.com",
  "s10.neositek.com",
  "s11.neositek.com",
  "s12.neositek.com",
  "s13.neositek.com",
  "s14.neositek.com",
  "s15.neositek.com",
  "s16.neositek.com",
  "s17.neositek.com",
  "s18.neositek.com",
  "s19.neositek.com",
  "s20.neositek.com",
  "s0.2kbo.com",
  "s1.2kbo.com",
  "s2.2kbo.com",
  "s3.2kbo.com",
  "s4.2kbo.com",
  "s5.2kbo.com",
  "s6.2kbo.com",
  "s7.2kbo.com",
  "s8.2kbo.com",
  "s9.2kbo.com",
  "s10.2kbo.com",
  "s11.2kbo.com",
  "s12.2kbo.com",
  "s13.2kbo.com",
  "s14.2kbo.com",
  "s15.2kbo.com",
  "s16.2kbo.com",
  "s17.2kbo.com",
  "s18.2kbo.com",
  "s19.2kbo.com",
  "s20.2kbo.com",
];

export function setTenantHost(server) {
  localStorage.setItem("tenantUrl", "https://" + server + ":7000/");
  localStorage.setItem("tenantPbxUrl", "https://" + server + ":8500/");
}

export function setTenant(server, key) {
  setTenantHost(server);
  localStorage.setItem("tenantKey", key);
}

export function clearTenant() {
  localStorage.removeItem("tenantUrl");
  localStorage.removeItem("tenantPbxUrl");
  localStorage.removeItem("tenantKey");
}

export function getTenant() {
  return {
    url: localStorage.getItem("tenantUrl"),
    pbxUrl: localStorage.getItem("tenantPbxUrl"),
    key: localStorage.getItem("tenantKey"),
  };
}

export async function loginThroughAnyServer(username, password) {
  let response = null;
  const pool = flavours.computed.isNeositek() ? neositekServerPool : serverPool;
  for (var poolIndex = 0; poolIndex < pool.length; poolIndex++) {
    const host = pool[poolIndex];
    try {
      response = await axios.get(`https://${host}:7000/operators/login`, {
        params: {
          opUser: username.trim(),
          pwd: password,
        },
      });
      if (response && response.status === 200) {
        break;
      }
    } catch (error) {
      continue;
    }
  }
  return response;
}

export async function getTenantClientWithAuthCode(code) {
  let currentHost = null;
  let token = null;
  const pool = flavours.computed.isNeositek() ? neositekServerPool : serverPool;
  for (var poolIndex = 0; poolIndex < pool.length; poolIndex++) {
    const host = pool[poolIndex];
    try {
      const response = await axios.get(`https://${host}:7000/operators/codeAuth`, {
        params: {
          code,
        },
      });
      if (response && response.status === 200) {
        currentHost = host;
        token = response.data.token;
        break;
      }
    } catch (error) {
      continue;
    }
  }
  return {
    host: currentHost,
    token,
  };
}

export async function getTenantClientForCabbie(phoneNumber, license) {
  let currentHost = null;
  const pool = flavours.computed.isNeositek() ? neositekServerPool : serverPool;
  for (var poolIndex = 0; poolIndex < pool.length; poolIndex++) {
    const host = pool[poolIndex];
    try {
      const response = await axios.get(`https://${host}:7000/operators/equip/code`, {
        params: {
          phone: phoneNumber,
          license,
        },
      });
      if (response && response.status === 204) {
        currentHost = host;
        break;
      }
    } catch (error) {
      continue;
    }
  }
  return currentHost;
}

export async function getTenantClient(phoneNumber, username, password) {
  let currentHost = null;
  const pool = flavours.computed.isNeositek() ? neositekServerPool : serverPool;
  for (var poolIndex = 0; poolIndex < pool.length; poolIndex++) {
    const host = pool[poolIndex];
    try {
      const response = await axios.get(`https://${host}:7000/operators/equip/code2`, {
        params: {
          phone: phoneNumber,
          user: username,
          password,
        },
      });
      if (response && response.status === 204) {
        currentHost = host;
        break;
      }
    } catch (error) {
      continue;
    }
  }
  return currentHost;
}

export async function getTenantClientWithCode(phoneNumber, username, password) {
  let currentHost = null;
  const pool = flavours.computed.isNeositek() ? neositekServerPool : serverPool;
  for (var poolIndex = 0; poolIndex < pool.length; poolIndex++) {
    const host = pool[poolIndex];
    try {
      const response = await axios.get(`https://${host}:7000/operators/equip/code2`, {
        params: {
          phone: phoneNumber,
          user: username,
          password,
        },
      });
      if (response && response.status === 204) {
        currentHost = host;
        break;
      }
    } catch (error) {
      continue;
    }
  }
  return currentHost;
}
